<template>
  <v-app>
    <v-navigation-drawer
      v-if="user_loggedIn"
      v-model="drawer"
      app
    >
      <v-list>
        <v-list-item>
          <v-list-item-icon>
            <v-icon color="primary">mdi-account-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ user_name }}</v-list-item-title>
        </v-list-item>

        <v-divider />

        <v-list-item to="/home" link>
          <v-list-item-action>
            <v-icon>mdi-bell-ring</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ routeTitle('/home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/statistics" link>
          <v-list-item-action>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ routeTitle('/statistics') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/customers" link>
          <v-list-item-action>
            <v-icon>mdi-face-agent</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ routeTitle('/customers') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/services" v-if="user_isAdministrator" link>
          <v-list-item-action>
            <v-icon>mdi-format-list-bulleted-square</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ routeTitle('/services') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item to="/users" v-if="user_isAdministrator" link>
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ routeTitle('/users') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider/>

        <v-list-item v-on:click="showPassword = true">
          <v-list-item-action>
            <v-icon>mdi-textbox-password</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Modifica password</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider/>

        <v-list-item to="/logout" link>
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ routeTitle('/logout') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar color="primary" app dark>
      <v-app-bar-nav-icon v-on:click.stop="drawer = !drawer" v-if="user_loggedIn" />
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <div>
        <v-img
          alt="Omniaevo Logo"
          src="@/assets/logo.svg"
          max-height="60"
          contain
        />
      </div>
    </v-app-bar>

    <v-content>
      <change-password v-model="showPassword" />
      <messages />
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import Messages from './components/Messages';
import ChangePassword from './components/ChangePassword';
import user from './mixins/user';
import server from './mixins/server';

export default {
  name: 'App',

  components: { Messages, ChangePassword },

  mixins: [ user, server ],

  data: () => ({
    drawer: null,
    showPassword: false,
  }),

  mounted: function() {
    // Check if the user has logged in
    this.server_query({
      url: 'User/current',
      onSuccess: this.user_set
    });
  },

  computed: {
    title: function() {
      return this.$route.meta.title;
    },
  },

  methods: {
    routeTitle: function(path) {
      const routes = this.$router.options.routes;

      for (let index = 0; index < routes.length; index++) {
        if (routes[index].path === path) {
          return ('meta' in routes[index]) ? routes[index].meta.title : '';
        }
      }

      return '';
    }
  }
};
</script>

<style>
@import './assets/global.css';
</style>